import { useDispatch } from "react-redux";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";

import { IState, TExtraThunkArgs } from "./store.types";

export const useThunkDispatch = <TAction extends Action>() =>
    useDispatch<ThunkDispatch<IState, TExtraThunkArgs, TAction>>();
